import { Dispatch } from 'redux';
import {
  HOME_FETCH_POSTS_REQUEST,
  HOME_FETCH_POSTS_SUCCESS,
  HOME_FETCH_POSTS_FAILURE,
} from '@core/constants/actions';
import getAllPosts from '@core/api/posts/all';
import showToast from '@core/toasts/operations/showToast.operation';
import { getHomeViewRole } from '@app/selectors/home';

export const fetchHomePosts =
  (reset = false, educatorPosts = false, role?: string) =>
  async (dispatch: Dispatch, getState: any) => {
    const state = getState();
    const { postsLoading, postsHasMore, postsCursor } = state.home;
    const targetRole = role || getHomeViewRole(state) || undefined;

    if (!reset && (postsLoading || !postsHasMore)) {
      return;
    }

    dispatch({ type: HOME_FETCH_POSTS_REQUEST, reset, educatorPosts });

    try {
      const response = await getAllPosts({
        until: reset
          ? undefined
          : postsCursor
          ? new Date(postsCursor)
          : undefined,
        after: undefined,
        audience: educatorPosts ? 'educator' : undefined,
        role: targetRole,
      });
      const rawPosts = (response as any)?.posts || [];
      const tagPosts = (response as any)?.tagPosts || [];
      const comments = (response as any)?.comments || [];
      const reactions = (response as any)?.reactions || [];

      const fetchedPosts = rawPosts.map((post: any) => ({
        ...post,
        tagPosts: tagPosts.filter(
          (tp: any) => tp.post?.objectId === post.objectId
        ),
        comments: comments.filter((c: any) => c.entityId === post.objectId),
        reactions: reactions.filter((r: any) => r.itemId === post.objectId),
      }));

      // Default limit on server is 20
      const hasMore = fetchedPosts.length >= 20;
      const nextCursor =
        fetchedPosts.length > 0
          ? fetchedPosts[fetchedPosts.length - 1].createdAt
          : null;

      // Check if viewRole changed while this fetch was in flight
      const currentRole = getHomeViewRole(getState());
      if (targetRole && currentRole && targetRole !== currentRole) {
        return;
      }

      dispatch({
        type: HOME_FETCH_POSTS_SUCCESS,
        posts: fetchedPosts,
        cursor: nextCursor,
        hasMore,
        reset,
      });
    } catch (error) {
      console.error('Failed to fetch home posts', error);
      dispatch({ type: HOME_FETCH_POSTS_FAILURE });

      // @ts-ignore
      (dispatch as any)(
        showToast({
          message: 'Failed to fetch posts',
          variant: 'error',
        })
      );
    }
  };
